import type { RemoteQuizConfig, UrlQuizConfig } from '@/modules/quiz/onboardingSettings';

export type ConfigBinding = 'urlProvider' | 'amplitudeProvider' | 'firebaseProvider';

/** Provider metadata; sent to `analytics.init` as `configsMetadata`. */
export interface ConfigMetadata {
  configName: string | null;
  config: Record<string, unknown> | null;
  validity: boolean | null;
  validationErrors: string[] | null;
}

export interface RemoteConfigProvider<T = RemoteQuizConfig> {
  readonly binding: ConfigBinding;
  init(): Promise<void>;
  readonly config: T | null;
  readonly metadata: ConfigMetadata;
}

export interface ResolvedConfigs {
  url: UrlQuizConfig;
  amplitude: RemoteQuizConfig | null;
  firebase: RemoteQuizConfig | null;
  metadata: Partial<Record<ConfigBinding, ConfigMetadata>>;
}

export const emptyMetadata = (configName: string | null = null): ConfigMetadata => ({
  configName,
  config: null,
  validity: null,
  validationErrors: null,
});
